/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResponseErrorBadRequestAllOfError } from './ResponseErrorBadRequestAllOfError';
import {
    ResponseErrorBadRequestAllOfErrorFromJSON,
    ResponseErrorBadRequestAllOfErrorFromJSONTyped,
    ResponseErrorBadRequestAllOfErrorToJSON,
} from './ResponseErrorBadRequestAllOfError';

/**
 * 
 * @export
 * @interface ResponseErrorBadRequest
 */
export interface ResponseErrorBadRequest {
    /**
     * 
     * @type {ResponseErrorBadRequestAllOfError}
     * @memberof ResponseErrorBadRequest
     */
    error: ResponseErrorBadRequestAllOfError;
}

/**
 * Check if a given object implements the ResponseErrorBadRequest interface.
 */
export function instanceOfResponseErrorBadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function ResponseErrorBadRequestFromJSON(json: any): ResponseErrorBadRequest {
    return ResponseErrorBadRequestFromJSONTyped(json, false);
}

export function ResponseErrorBadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorBadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': ResponseErrorBadRequestAllOfErrorFromJSON(json['error']),
    };
}

export function ResponseErrorBadRequestToJSON(value?: ResponseErrorBadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': ResponseErrorBadRequestAllOfErrorToJSON(value.error),
    };
}

